var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"confirmationModal",attrs:{"title":"Confirmation","centered":""},on:{"ok":_vm.confirmDelete}},[_vm._v(" "+_vm._s(_vm.confirmText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }